<template>
  <div :style="{ 'font-size': size }">
    <q-spinner-puff color="primary-pure" />
  </div>
</template>

<script setup>
const props = defineProps({
  size: {
    type: String,
    default: '3rem',
  },
})
</script>
